import { initDateExtenstions } from "./dateExtenstions";
import { initStringExtenstions } from "./stringExtenstions";

const initExtenstions = () => {
  initDateExtenstions();
  initStringExtenstions();
}

export default initExtenstions;